import {RemotePostConfirmEmail} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PostConfirmEmail} from 'domain/usecases';

export const makePostConfirmEmail = (): PostConfirmEmail =>
	new RemotePostConfirmEmail(
		makeBFFApiUrl(ProfileChangeDataEndpoints.checkEmail),
		makeAuthorizeHttpClientDecorator(),
	);
